module.exports = require("./nyn.js");